import React from 'react';
import {FadeIn} from './ui/FadeIn';
import {Accordion} from './ui/Accordion';

const faqs=[
  {
    question: "Do you work with startups that don't have product-market fit yet?",
    answer: "Usually no. Cold outbound multiplies whatever message you put in front of buyers. If the message isn't yet validated by paying customers, you'll just get fast, expensive proof that something else is broken. I'll happily tell you on the first call whether you're ready, and what to do if you're not."
  },
  {
    question: "How long does it take to see results?",
    answer: "For most engagements, 4 to 8 weeks of calibration before reply rates and meeting volume settle into something predictable. Anyone promising faster either got lucky or is about to burn your sender reputation. The right question isn't \"when will I see leads,\" it's \"when will I see the right leads.\""
  },
  {
    question: "Do you write the emails yourself?",
    answer: "Every word. I don't outsource writing, and I don't use AI to draft sequences. After 20 years of filing copy on deadline, I'm faster by hand than anyone is with a prompt. If you can't tell the difference between handwritten and AI copy, your prospects can."
  },
  {
    question: "What tools do you recommend?",
    answer: "I'm tool-agnostic. I've worked across Instantly, Apollo, Smartlead, Lemlist, HubSpot, Clay, and a dozen data providers. The right stack depends on your motion, your volume, your ICP size, your sending infrastructure, and your team. We'll choose together, not before."
  },
  {
    question: "Do you guarantee a certain number of meetings?",
    answer: "No honest consultant does. Outbound depends on your offer, your market, and the quality of your list, most of which are inputs I don't fully control. What I guarantee is the same rigor I brought to two decades of journalism, and that if I think you're wasting money I'll say so before you spend it."
  },
  {
    question: "Can we hire you to just run our campaigns end-to-end?",
    answer: "No. I consult, I don't operate. If you need a team to run sending, monitor deliverability, and manage replies day-to-day, I'll point you to operators I trust. What I do is help you decide what to send, to whom, and why, and review the work before it goes out."
  },
  {
    question: "How much of my time will this take?",
    answer: "For a Clarity Call: 60 minutes plus a short pre-call form. For a Sprint or Audit: roughly 2 to 4 hours of your time per week, mostly in working sessions and answering questions about your customers. For Fractional Advisor: two 60-minute meetings a month, plus async messages."
  },
  {
    question: "Do you work with B2C companies?",
    answer: "No. My experience is in B2B, specifically marketing agencies, IT and software firms, consulting, and staffing companies in the US and UK. If you're outside that, send a message anyway. I'll be honest about whether I can help."
  },
  {
    question: "What happens after the engagement ends?",
    answer: "You own everything we built, the lists, the sequences, the documentation, the strategy. I stay reachable by email for follow-up questions for 30 days at no charge. After that, most clients either book a Clarity Call when something specific comes up, or move onto the Fractional Advisor retainer."
  },
  {
    question: "Why rely on cold email when inbound exists?",
    answer: "You shouldn't choose. Inbound builds trust over months and reaches buyers who are already searching. Outbound reaches the specific accounts you've decided you want, on your timeline. The companies that grow predictably run both, and the work I do makes outbound stop competing with inbound for budget."
  }
];

export function FAQ() {
  return (
    <section id="faq" className="py-section-mob md:py-section-desk bg-fog">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <FadeIn>
          <h2 className="font-heading text-h2-mob md:text-h2-desk text-ink mb-12 md:mb-16 max-w-[700px]"> Questions founders ask before booking </h2>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div className="max-w-[800px]">
            <Accordion items={faqs} />
          </div>
        </FadeIn>
      </div>
    </section>
  );
}